import { CaseTypes } from '@portalCommon/constants';
import classnames from 'classnames/bind';
import { PageTop, TopCard, Demand, Features, Process, Advantage } from '../components/';
import styles from '../index.module.less';

const cx = classnames.bind(styles);

export const CarShow = ({ type }: { type: CaseTypes }) => {
  return (
    <>
      <PageTop
        title="车展展览解决方案"
        brief="	
        酷炫汽车一比一复刻进虚拟场景，汽车爱好者足不出户沉浸看展，行业人员在线高效交流，未来感十足的在线车展。"
        bg="https://static.fuxi.netease.com/yaotai/portal/20220905/l7oh4ki7_877263.png"
      />
      <div className={cx('top-module')}>
        <TopCard type={type}></TopCard>
        <Demand type={type} title={['科技让在线车展', '有体验、有颜值、有场面']} />
      </div>

      <Features type={type} title={['在线车展方案', '特色功能']} subtitle="丰富功能，满足在线车展场景需求" />
      <Process></Process>
      <Advantage type={type} title={['车展展览', '方案优势']}></Advantage>
    </>
  );
};
